// extracted by mini-css-extract-plugin
module.exports = {"root":"VariableEditor_root__P7OE_","inner":"VariableEditor_inner__eE541"};